export type Environment = 'development' | 'test' | 'staging' | 'hml' | 'clone' | 'production'

export interface EnvironmentConfig {
  name: Environment
  displayName: string
  logoPath: string
  iconPrefix: string
  faviconPath: string
  appleTouchIconPath: string
  dns: `/${'s' | 'c' | 'h' | 'd' | ''}ventas`
}

export const ENVIRONMENT_CONFIGS: Record<Environment, EnvironmentConfig> = {
  development: {
    name: 'development',
    displayName: 'Desenvolvimento',
    logoPath: '/images/ventas_dev.svg',
    iconPrefix: 'dev',
    faviconPath: '/icons/favicon-dev.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-dev.png',
    dns: '/dventas',
  },
    test: {
    name: 'test',
    displayName: 'Desenvolvimento',
    logoPath: '/images/ventas_dev.svg',
    iconPrefix: 'dev',
    faviconPath: '/icons/favicon-dev.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-dev.png',
    dns: '/dventas',
  },
  staging: {
    name: 'staging',
    displayName: 'Staging',
    logoPath: '/images/ventas_staging.svg',
    iconPrefix: 'staging',
    faviconPath: '/icons/favicon-staging.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-staging.png',
    dns: '/sventas',
  },
  hml: {
    name: 'hml',
    displayName: 'Homologação',
    logoPath: '/images/ventas_hml.svg',
    iconPrefix: 'hml',
    faviconPath: '/icons/favicon-hml.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-hml.png',
    dns: '/hventas',
  },
  clone: {
    name: 'clone',
    displayName: 'Testes',
    logoPath: '/images/ventas_clone.svg',
    iconPrefix: 'clone',
    faviconPath: '/icons/favicon-clone.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-clone.png',
    dns: '/cventas',
  },
  production: {
    name: 'production',
    displayName: '',
    logoPath: '/images/ventas-prod.svg',
    iconPrefix: 'prod',
    faviconPath: '/icons/favicon-prod.ico',
    appleTouchIconPath: '/icons/apple-touch-icon-180x180-prod.png',
    dns: '/ventas',
  },
}

export function getCurrentEnvironmentConfig(mode: string = 'development'): EnvironmentConfig {
  return ENVIRONMENT_CONFIGS[mode as Environment] || ENVIRONMENT_CONFIGS.development
}
export function getCurrentLogoPath(mode: string): string {
  return getCurrentEnvironmentConfig(mode).logoPath
}

export function getCurrentIconPrefix(mode: string): string {
  return getCurrentEnvironmentConfig(mode).iconPrefix
}

export function getAllEnvironmentConfigs(): EnvironmentConfig[] {
  return Object.values(ENVIRONMENT_CONFIGS)
}
